import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router'
import withHooks from 'cityads-v3/decorators/withHooks'

import { sendEvent } from 'cityads-v3/utils/htmlUtils';

@withHooks(props => ({
  ...props,
  history: useHistory()
}))
export default class AuthIFrame extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    onEvent: PropTypes.func,
    onResize: PropTypes.func,
    onLoad: PropTypes.func,
    onFail: PropTypes.func,
    onMessage: PropTypes.func,
    onMount: PropTypes.func,
  }

  onMessage(evt) {
    let source = evt.source;
    let iframe = this.iframe;

    if (iframe.contentWindow !== source) {
      return;
    }

    const { loaded, resize, failed, event } = evt.data;
    const { onResize, onLoad, onFail, onEvent } = this.props;

    if (resize) {
      let oldHeight = iframe.style.height;
      let newHeight = Number(resize.height) + 'px';

      if (oldHeight !== newHeight) {
        iframe.style.height = newHeight;

        if (typeof window !== 'undefined') {
          sendEvent(window, 'resize');
        }
      }

      if (onResize) {
        onResize.call(this, evt)
      }
    }

    if (loaded) {
      if (onLoad) {
        onLoad.call(this, evt)
      }
    }

    if (failed) {
      if (onFail) {
        onFail.call(this, evt)
      }
    }

    if (event) {
      if (onEvent) {
        onEvent.call(this, evt)
      }

      if (event === 'navigate') {
        this.props.history.push(evt.data.data)
      }
    }
  }

  componentDidMount() {
    const { onMount } = this.props;

    if (typeof window !== 'undefined') {
      window.addEventListener('message', this.messageHandler = this.onMessage.bind(this));
    }

    if (typeof onMount === 'function') {
      onMount({
        iframe: this.iframe
      });
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined' && this.messageHandler) {
      window.removeEventListener('message', this.messageHandler);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.saveFormData && nextProps.src !== this.props.src) {
      this.iframe.contentWindow.postMessage({
        command: 'save_form_data'
      }, '*');
    }
  }

  render() {
    const { saveFormData, onResize, onLoad, onFail, onEvent, onMount, title, onMessage, ...rest } = this.props;

    return <iframe ref={(iframe) => { this.iframe = iframe; }} scrolling="no" title={title} {...rest}></iframe>
  }
}
